import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const base = {
    viewBox: '0 0 16 16',
    width: '1em',
    height: '1em',
    fill: 'none',
    stroke: 'currentcolor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
    focusable: false,
};
export function CheckIcon(props) {
    return (_jsx("svg", { ...base, ...props, children: _jsx("path", { d: "M3 8.5 6.5 12 13 4.5" }) }));
}
export function DashIcon(props) {
    return (_jsx("svg", { ...base, ...props, children: _jsx("path", { d: "M3.5 8h9" }) }));
}
export function ChevronDownIcon(props) {
    return (_jsx("svg", { ...base, ...props, children: _jsx("path", { d: "m3.5 6 4.5 4.5L12.5 6" }) }));
}
export function ChevronUpIcon(props) {
    return (_jsx("svg", { ...base, ...props, children: _jsx("path", { d: "m3.5 10 4.5-4.5L12.5 10" }) }));
}
export function CloseIcon(props) {
    return (_jsx("svg", { ...base, ...props, children: _jsx("path", { d: "m4 4 8 8M12 4l-8 8" }) }));
}
export function AlertIcon(props) {
    return (_jsxs("svg", { ...base, ...props, children: [_jsx("path", { d: "M8 2.5 15 14H1z" }), _jsx("path", { d: "M8 6.5v3.2M8 11.8v.2" })] }));
}
//# sourceMappingURL=icons.js.map